import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownButton',
  props: ['label', 'isOpen'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["q-btn q-btn q-btn-sm q-bg-white q-dropdown-toggle q-pe-5 q-position-relative q-mb-1 q-rounded-3 q-shadow-sm q-fw-semibold", {'dropdown__open': __props.isOpen}]),
    type: "button",
    "aria-expanded": "false"
  }, _toDisplayString(__props.label), 3))
}
}

})